export const probablyMobileDevice = () => {
  return window.navigator.msMaxTouchPoints || "ontouchstart" in document;
};
